import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, renderList as _renderList, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-close"
}
const _hoisted_2 = {
  key: 1,
  class: "home-numbers-loading"
}
const _hoisted_3 = {
  key: 2,
  class: "home-numbers"
}
const _hoisted_4 = { class: "home-numbers-head" }
const _hoisted_5 = { class: "home-numbers-icon" }
const _hoisted_6 = { class: "home-numbers-title" }
const _hoisted_7 = { class: "home-numbers-l" }
const _hoisted_8 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "home-numbers-actions" }
const _hoisted_11 = {
  key: 1,
  class: "home-numbers-done"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.popup ? 'error-msg-wrap' : '')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.popup ? 'form-wrapper slide-up home-numbers-popup' : '')
    }, [
      (_ctx.popup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]))
        : _createCommentVNode("", true),
      (_ctx.popup && !_ctx.numbersLoaded)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Loading your numbers…"))
        : _createCommentVNode("", true),
      (_ctx.numbersLoaded && (_ctx.popup || _ctx.missing.length || _ctx.numbersSaved))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_svg_icon, { icon: "chart" })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("b", null, "Your Numbers" + _toDisplayString(_ctx.headerWeek ? ' for ' + _ctx.titleCase(_ctx.relativeWeekLabel(_ctx.headerWeek)) : ''), 1),
                _createElementVNode("span", null, [
                  (_ctx.headerWeek)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.weekRangeNumbered(_ctx.headerWeek)), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.missing.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.headerWeek ? ' · ' : '') + _toDisplayString(_ctx.missing.length) + " still to enter", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("a", {
                class: "home-numbers-open",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openScorecard()), ["prevent"]))
              }, "Open Scorecard")
            ]),
            (_ctx.missing.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missing, (m) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: m.ID,
                      class: "home-numbers-row"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("b", null, _toDisplayString(m.Name), 1),
                        _createElementVNode("span", null, [
                          (!_ctx.headerWeek)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.relativeWeekLabel(_ctx.dueWeekFor(m))) + " · ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString(_ctx.teamLabel(m.Team)) + " · goal " + _toDisplayString(_ctx.goalText(m, _ctx.dueWeekFor(m))) + " · week before " + _toDisplayString(_ctx.hasValue(m, _ctx.addDays(_ctx.dueWeekFor(m), -7)) ? _ctx.formatValue(m, m.Values[_ctx.addDays(_ctx.dueWeekFor(m), -7)]) : '—') + " · due " + _toDisplayString(_ctx.dueText(m.DueDay, m.DueTime)), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["home-numbers-in", _ctx.inputClass(m)])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          step: "any",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.numbers[m.ID]) = $event),
                          placeholder: "—",
                          "aria-label": m.Name,
                          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.saveNumbers()), ["enter"]))
                        }, null, 40, _hoisted_8), [
                          [_vModelText, _ctx.numbers[m.ID]]
                        ]),
                        (m.Unit)
                          ? (_openBlock(), _createElementBlock("em", _hoisted_9, _toDisplayString(m.Unit), 1))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "home-numbers-hint" }, "Green means on goal. Leave any you don't have yet.", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.savingNumbers ? 'disable-button' : '']),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveNumbers()))
                    }, "Save Numbers", 2)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_svg_icon, { icon: "check" }),
                  _createTextVNode("All your numbers are in" + _toDisplayString(_ctx.headerWeek ? ' for ' + _ctx.relativeWeekLabel(_ctx.headerWeek).toLowerCase() : '') + ".", 1)
                ]))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}